import { getElementDataRoot } from '../../constants/getElementDataRoot'
import { Map } from 'immutable'

export const createComponentSelector = (uid, PageID) => (state) => {
  return state.getIn([...getElementDataRoot(PageID), 'elements', uid], new Map())
}

export const createStylesRefSelector = (uid, PageID) => (state) => {
  return createComponentSelector(uid, PageID)(state).getIn(['props', 'styleRef'])
}

export const createProjectSettingsStyleRefSelector = (styleRef) => (state) => {
  return state.getIn(['project', 'Settings', 'styles', styleRef], Map())
}

export const createIsStyleRefGlobalSelector = (styleRef) => (state) => {
  return state.getIn(['project', 'Settings', 'styles', styleRef, 'isGlobal'])
}

export const createProjectComponentStyleSelector = (uid, PageID) => (state) => {
  const selectStyleRef = createStylesRefSelector(uid, PageID)
  const styleRef = selectStyleRef(state)

  const selectProjectSettingsBasedOnStyleRef = createProjectSettingsStyleRefSelector(styleRef)
  const styleMap = selectProjectSettingsBasedOnStyleRef(state)
  const { isGlobal } = styleMap.toJS()

  if (isGlobal) {
    return styleMap
  } else {
    return state.getIn([...getElementDataRoot(PageID), 'styles', styleRef], Map())
  }
}
